import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('iron_horse', {
  cherry: 'coal_shovel',
  lemon: 'signal_lamp',
  orange: 'coal_pile',
  bell: 'train_bell',
  star: 'locomotive_wild',
  seven: 'railroad_track',
  gem: 'pocket_watch',
  scatter: 'steam_whistle_scatter',
  money: 'express_box',
});

/** Iron Horse — GENERATED by scaffoldSlot from
 *  content/slots/iron_horse.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const IRON_HORSE_THEME: Theme = {
  id: 'iron_horse',
  name: 'Iron Horse',
  palette: {
    accent: 0x5e6670,
    secondary: 0x9aa0a8,
    warm: 0xf2d27a,
    frameFill: 0x1d2026,
    bgGradientTop: 0x343941,
    bgGradientBottom: 0x101216,
    dimOverlay: 0x07080a,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Coal Shovel', glyph: '🪏', tint: 0x8a8a8a, weight: 5, textureAlias: 'iron_horse:cherry',
        winVideoAlias: 'iron_horse:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Signal Lamp', glyph: '🏮', tint: 0xe0a83a, weight: 5, textureAlias: 'iron_horse:lemon',
        winVideoAlias: 'iron_horse:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Coal', glyph: '⚫', tint: 0x3a3a3a, weight: 4, textureAlias: 'iron_horse:orange',
        winVideoAlias: 'iron_horse:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Train Bell', glyph: '🔔', tint: 0xd0a84e, weight: 3, textureAlias: 'iron_horse:bell',
        winVideoAlias: 'iron_horse:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Iron Horse', glyph: '🚂', tint: 0x5e6670, weight: 2, textureAlias: 'iron_horse:star',
        winVideoAlias: 'iron_horse:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Railway', glyph: '🛤️', tint: 0x7a6a5a, weight: 2, textureAlias: 'iron_horse:seven',
        winVideoAlias: 'iron_horse:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Conductor\'s Watch', glyph: '⏱️', tint: 0xe0c060, weight: 2.5, textureAlias: 'iron_horse:gem',
        winVideoAlias: 'iron_horse:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Steam Whistle', glyph: '🚨', tint: 0xc0a060, weight: 0.5, textureAlias: 'iron_horse:scatter',
        winVideoAlias: 'iron_horse:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Express Box', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'iron_horse:money',
        winVideoAlias: 'iron_horse:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x1d2026, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x5e6670, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x1d2026, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x9aa0a8, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x5e6670, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x1d2026, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x5e6670, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xf2d27a, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'iron_horse:bg', path: 'environment/iron_horse.png' },
      columnBackground: { alias: 'iron_horse:column_bg', path: 'reel/iron_horse_column_bg.png' },
      border: { alias: 'iron_horse:border', path: 'brand/border_frontier.png' },
    },
  },
};
